import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/(partner)/partner/sdk/page.tsx");
